module.exports = __webpack_public_path__ + "static/media/cancelled-icon.42b4bfa6.svg";